import * as React from 'react';

import { kebabCase } from 'lodash';

import { CardBlock } from './CardBlock';
import { Header } from '../Common/common.styles';
import { FlexContainer, UnstyledLink } from './WhyOrigin.styles';
import { IWhyOrigin } from '../../../src/models/content.interfaces';

export const WhyOrigin = ({ headline, items }: IWhyOrigin) => (
  <div data-id="why-origin-container">
    <Header data-id="why-origin-title">
      <h1 data-id="leading">{headline}</h1>
    </Header>
    <FlexContainer data-id="container">
      {(items || []).map((card) => {
        const cardBlock = (
          <CardBlock
            data-id="why-origin-card"
            key={card.headline}
            title={card.headline}
            content={card.byline}
            imageSHA={card.imageSHA}
            buttonLabel={card.buttonLabel}
          />
        );

        return card.href ? (
          <UnstyledLink
            trackingType="CustomLink"
            trackingLabel={kebabCase(card.headline)}
            href={card.href}
            key={card.headline}
            data-id={`why-origin-${kebabCase(card.headline)}`}
            target={card.newTab ? '_blank' : '_self'}
          >
            {cardBlock}
          </UnstyledLink>
        ) : (
          cardBlock
        );
      })}
    </FlexContainer>
  </div>
);
